export default "__VITE_ASSET__D3ek0zVV__"